/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imageGetImageBingDaily } from "../../funcs/imageGetImageBingDaily.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$imageGetImageBingDaily: ToolDefinition = {
  name: "image-get-image-bing-daily",
  description: `必应壁纸

每天都想换张新壁纸？让必应的美图点亮你的一天吧！

## 功能概述
这个接口会获取 Bing 搜索引擎当天全球同步的每日壁纸，并直接以图片形式返回。你可以用它来做应用的启动页、网站背景，或者任何需要每日更新精美图片的地方。

## 使用须知

> [!NOTE]
> **响应格式是图片**
> 请注意，此接口成功时直接返回图片二进制数据（通常为 \`image/jpeg\`），而非 JSON 格式。请确保客户端能够正确处理。

我们内置了备用方案：如果从必应官方获取图片失败，系统会尝试返回一张预存的高质量风景图，以保证服务的稳定性。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  tool: async (client, ctx) => {
    const [result] = await imageGetImageBingDaily(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
